export default class MapboxStyle {

    constructor(options = {}) {
        this.options = Object.assign({
            name: 'jiufang',
            glyphs: '',
            sprite: ''
        }, options)
        this.style = {
            version: 8,
            name: this.options.name,
            zoom: 0.8619833357855968,
            pitch: 0,
            bearing: 0,
            center: [0, 0],
            metadata: {},
            layers: [],
            sources: {}
        }
        if(this.options.sprite) {
            this.style.sprite = this.options.sprite
        }
        if(this.options.glyphs) {
            this.style.glyphs = this.options.glyphs
        }
    }

    setLayers(layers) {
        this.style.layers = layers
    }

    setSources(sources) {
        this.style.sources = sources
    }

    getStyleJSON() {
        return this.style
    }
}